"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SJ = void 0;
exports.SJ = {
    numericCode: '744',
    alpha2Code: 'SJ',
    alpha3Code: 'SJM',
    englishName: {
        short: 'Svalbard and Jan Mayen',
        full: 'Svalbard and Jan Mayen',
    },
    names: {
        full: {
            en: 'Svalbard and Jan Mayen',
            fr: "Svalbard et l'Île Jan Mayen (le)",
            nn: 'Svalbard og Jan Mayen',
            nb: 'Svalbard og Jan Mayen',
        },
        short: {
            en: 'Svalbard and Jan Mayen',
            fr: "Svalbard et l'Île Jan Mayen (le)",
            nn: 'Svalbard og Jan Mayen',
            nb: 'Svalbard og Jan Mayen',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'nn',
            languageAlpha3Code: 'nno',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'nb',
            languageAlpha3Code: 'nob',
            isAdministrative: true,
        },
    ],
    subdivisions: {},
    cities: [
        {
            name: 'Longyearbyen',
            subdivision: 'Svalbard',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU0ouanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY291bnRyaWVzL2RhdGEvU0oudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7O0dBSUc7OztBQU1VLFFBQUEsRUFBRSxHQUFZO0lBQ3ZCLFdBQVcsRUFBRSxLQUFLO0lBQ2xCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFdBQVcsRUFBRTtRQUNULEtBQUssRUFBRSx3QkFBd0I7UUFDL0IsSUFBSSxFQUFFLHdCQUF3QjtLQUNqQztJQUNELEtBQUssRUFBRTtRQUNILElBQUksRUFBRTtZQUNGLEVBQUUsRUFBRSx3QkFBd0I7WUFDNUIsRUFBRSxFQUFFLGtDQUFrQztZQUN0QyxFQUFFLEVBQUUsdUJBQXVCO1lBQzNCLEVBQUUsRUFBRSx1QkFBdUI7U0FDOUI7UUFDRCxLQUFLLEVBQUU7WUFDSCxFQUFFLEVBQUUsd0JBQXdCO1lBQzVCLEVBQUUsRUFBRSxrQ0FBa0M7WUFDdEMsRUFBRSxFQUFFLHVCQUF1QjtZQUMzQixFQUFFLEVBQUUsdUJBQXVCO1NBQzlCO0tBQ0o7SUFDRCxTQUFTLEVBQUU7UUFDUDtZQUNJLGtCQUFrQixFQUFFLElBQUk7WUFDeEIsa0JBQWtCLEVBQUUsS0FBSztZQUN6QixnQkFBZ0IsRUFBRSxLQUFLO1NBQzFCO1FBQ0Q7WUFDSSxrQkFBa0IsRUFBRSxJQUFJO1lBQ3hCLGtCQUFrQixFQUFFLEtBQUs7WUFDekIsZ0JBQWdCLEVBQUUsS0FBSztTQUMxQjtRQUNEO1lBQ0ksa0JBQWtCLEVBQUUsSUFBSTtZQUN4QixrQkFBa0IsRUFBRSxLQUFLO1lBQ3pCLGdCQUFnQixFQUFFLElBQUk7U0FDekI7UUFDRDtZQUNJLGtCQUFrQixFQUFFLElBQUk7WUFDeEIsa0JBQWtCLEVBQUUsS0FBSztZQUN6QixnQkFBZ0IsRUFBRSxJQUFJO1NBQ3pCO0tBQ0o7SUFDRCxZQUFZLEVBQUUsRUFBRTtJQUNoQixNQUFNLEVBQUU7UUFDSjtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxVQUFVO1NBQzFCO0tBQ0o7Q0FDSixDQUFBIn0=